import { FirearmPoolResolverBase } from './firearm-pool.resolver.base';
import { FirearmPoolService } from './firearm-pool.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class FirearmPoolResolver extends FirearmPoolResolverBase {

  constructor(protected service: FirearmPoolService) {
    super(service);
  }
}



